import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';
import { ScriptService } from '../../services/script.service';
import { RuntimeService } from '../../services/runtime.service';

@Component({
    selector: 'text-editor',
    templateUrl: './text-editor.component.html',
    styleUrls: ['./text-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextEditorComponent),
            multi: true
        }
    ]
})
export class TextEditorComponent implements OnInit, OnDestroy {
    protected apiUrl = (environment?.scheme ?? 'http') + "://"
        + (environment?.domain ?? 'localhost')
        + (!environment?.port || ['443', '80'].indexOf('' + (environment?.port ?? '80')) >= 0 ? '' : ':' + environment?.port)
        + '/api/';

    private innerValue: string = '';

    private onTouchedCallback: () => void = () => { };
    private onChangeCallback: (_: any) => void = () => { };

    @Output() onChange = new EventEmitter();

    @Input() uploadImageApi: string = '/uploads/image';

    @Input()
    set value(value: any) {
        if (this.innerValue !== value) {
            this.innerValue = value;
            this.onChangeCallback(value);
            this.onChange.emit(value);
        }

        this.onTouchedCallback();
    }
    get value(): any {
        return this.innerValue;
    }

    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    registerOnChange(fn: (_: any) => void) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: () => void) {
        this.onTouchedCallback = fn;
    }

    public ckEditor: any = null;

    constructor(
        private scriptService: ScriptService,
        private authService: AuthService,
        private runtimeService: RuntimeService,
    ) { }

    ngOnInit(): void {
        const authToken = this.authService.user.getToken();

        this.scriptService.loadScript('/assets/js/ckeditor5/ckeditor.js?' + this.runtimeService?.getBuild()).then(status => {
            if (status.loaded) {
                // @ts-ignore
                this.ckEditor = window['ClassicEditor'];

                this.ckEditor.defaultConfig.simpleUpload = Object.assign(this.ckEditor.defaultConfig.simpleUpload, {
                    uploadUrl: this.apiUrl?.replace(/\/+$/, '') + '/' + this.uploadImageApi.replace(/^\//, ''),
                    headers: {
                        Authorization: 'Bearer ' + authToken,
                    }
                });
            }
        });
    }

    ngOnDestroy(): void {

    }

}
